// Purchase
import Purchase from '@/views/admin/Purchase.vue'
import PDeclined from '@/views/admin/purchase/Declined.vue'
import PAccepted from '@/views/admin/purchase/Accepted.vue'
import PPending from '@/views/admin/purchase/Pending.vue'

const purchaseRoutes = {
  path: '/hrd12/hrd12/purchase',
  component: Purchase,
  redirect: '/hrd12/hrd12/purchase/processed',
  name: 'Purchase',
  meta: {
    title: 'Sales'
  },
  children: [
    {
      path: '/hrd12/hrd12/purchase/declined',
      component: PDeclined,
      name: 'DeclinedPurchase',
      meta: {
        title: 'Declined Purchase'
      }
    },
    {
      path: '/hrd12/hrd12/purchase/processed',
      component: PAccepted,
      name: 'AcceptedPurchase',
      meta: {
        title: 'Accepted Purchase'
      }
    },
    {
      path: '/hrd12/hrd12/purchase/pending',
      component: PPending,
      name: 'PendingPurchase',
      meta: {
        title: 'Pending Purchase'
      }
    }
  ]
}

export default purchaseRoutes
